<template>
  <div v-if="lookupsLoaded" class="pb-5 px-md-3">
    <ValidationObserver v-slot="{ invalid }" ref="formValidationObserver">
      <b-form @submit.prevent="SaveProperty">
        <!--Title/Actions-->
        <div class="page-header">
          <div class="container d-flex justify-content-between p-0">
            <h3>
              <i class="fas fa-building"></i>&nbsp;Property
            </h3>
            <div class="d-flex align-items-center">
              <div v-if="propertyForEdit.id || propertyForEdit.isNew">
                <div>
                  <b-form-checkbox
                    v-model="propertyForEdit.isArchived"
                    name="check-button"
                    switch
                  ><span>Archive Property</span></b-form-checkbox>
                </div>
              </div>
              <router-link title="Close" :to="{ name: 'Properties'}">
                <b-button variant="light">Close</b-button>
              </router-link>
              <b-button type="submit" variant="primary" :disabled="invalid" class="ml-1">Save</b-button>
            </div>
          </div>
        </div>

        <div class="container form-container p-3 p-md-4">
          <label class="section-label">
            <i class="fas fa-info-circle"></i> Details
          </label>
          <div class="row">
            <div class="col-lg-3 col-md-4 col-12">
              <div class="form-group">
                <label class="control-label">Property#</label>
                <ValidationProvider name="Property Number" rules="required" v-slot="validation">
                  <b-form-input
                    placeholder="Property #"
                    v-model="propertyForEdit.propertyNumber"
                    :state="spr2_getValidationState(validation)"
                    name="Property Number"
                  />
                  <b-form-invalid-feedback id="name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-lg-6 col-md-8 col-12">
              <div class="form-group">
                <label class="control-label">Name</label>
                <ValidationProvider name="Name" rules="required" v-slot="validation">
                  <b-form-input
                    placeholder="Name"
                    v-model="propertyForEdit.name"
                    :state="spr2_getValidationState(validation)"
                    name="Name"
                    aria-describedby="name-feedback"
                  />
                  <b-form-invalid-feedback id="name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <label class="control-label"># of Units</label>
                <ValidationProvider name="# of Units" rules="required" v-slot="validation">
                  <b-form-input
                    placeholder="# of Units"
                    v-model.number="propertyForEdit.numberOfUnits"
                    :state="spr2_getValidationState(validation)"
                    type="number"
                    name="# of Units"
                  />
                  <b-form-invalid-feedback id="name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-12">
              <address-form
                ref="addressForm"
                v-model="propertyForEdit.address"
                :state-options="stateOptions"
                :country-options="countryOptions"
              />
            </div>
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <label class="control-label">Phone Number</label>
                <ValidationProvider
                    name="Phone Number"
                    rules="required|phoneNumber"
                    v-slot="validation"
                  >
                <b-form-input
                  placeholder="(555) 555-5555"
                  v-model="propertyForEdit.phoneNumber"
                    name="Phone Number"
                    :state="spr2_getValidationState(validation)"
                    aria-describedby="phone-number-feedback"
                    />
                    <b-form-invalid-feedback id="phone-number-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
              </div>
            </div>
          </div>
          <label class="section-label mt-5">
            <i class="fas fa-phone"></i> On Call Options
          </label>
          <div class="row">
            <div class="col-12">
              <div
                v-if="propertyForEdit.onCallPhoneNumberFriendlyFormat"
              >On Call Phone #: {{propertyForEdit.onCallPhoneNumberFriendlyFormat}}</div>
              <div v-else>
                <b-button
                  variant="light"
                  :disabled="!propertyForEdit.id"
                  @click="doCreatePropertyOnCallNumber(propertyForEdit.id)"
                >Enable On Call Phone #</b-button>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 pt-3">
              <div class="form-group">
                <label class="control-label">Person on call</label>
                <b-form-select class="w-100" :options="propertyOnCallPocOptions" v-model="selectedPocForOnCall">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Select a Person to be on call...</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <label class="section-label mt-5">
            <i class="fas fa-file-signature"></i> Insurance Policy
          </label>
           <div class="row">
            <div class="col-lg-4 col-md-4 col-6 pt-3 mb-5">
              <div class="form-group">
                <label class="control-label">Policy #</label>
                <b-form-input
                  placeholder="Policy #"
                  v-model="insurancePolicy.policyNumber"
                />
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-6 pt-3 mb-5">
              <div class="form-group">
                <label class="control-label">Contact Phone #</label>
                <ValidationProvider
                    name="Phone Number"
                    rules="phoneNumber"
                    v-slot="validation"
                  >
                <b-form-input
                  placeholder="(555) 555-5555"
                  :state="spr2_getValidationState(validation)"
                  v-model="insurancePolicy.contactNumber"
                />
                </ValidationProvider>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-6 pt-3 mb-5">
              <div class="form-group">
                <label class="control-label">Deductible Amount</label>
                <b-form-input type="number" step="any"
                  placeholder="Deductible Amount"
                  v-model.number="insurancePolicy.deductible"
                />
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../../mixins/Spr2SharedFunctions'
import AddressForm from '../../components/shared/AddressForm.vue'
export default {
  name: 'Properties',
  created () {
    Promise.all([this.doLoadProperty(), this.doLoadPropertyContacts(), this.getLookupStates(), this.getLookupCountries()]).then(
      () => {
        this.lookupsLoaded = true
      }
    )
  },
  mixins: [spr2Validation],
  components: { AddressForm },
  data () {
    return {
      modalOpen: false,
      propertyPocContacts: [],
      propertyForEdit: {
        address: {},
        name: null,
        id: null,
        numberOfUnits: null,
        insurancePolicies: []
      },
      insurancePolicy: {
        policyNumber: null,
        contactNumber: null,
        deductible: 0
      },
      lookupsLoaded: false
    }
  },
  computed: {
    stateOptions () {
      return (this.$store.state.lookups.states || []).map(s => ({
        value: s.abbreviation,
        text: s.name,
        country: s.country
      }))
    },
    countryOptions () {
      return this.$store.state.lookups.countries || []
    },
    propertyId () {
      return this.$route.params.id === 'new' ? null : this.$route.params.id
    },
    properties () {
      return this.$store.state.company.properties
    },
    selectedPocForOnCall: {
      get: function () {
        return this.propertyForEdit.onCallPersonId
      },
      set: function (val) {
        console.log('selected for oncall = ' + val)
        this.propertyForEdit.onCallPersonId = val
      }
    },
    propertyOnCallPocOptions () {
      var project = (o, p) => {
        return { text: o.name, value: o.id }
      }
      var pocContacts = this.propertyPocContacts
      var results = []

      for (var i = 0; i < pocContacts.length; i++) {
        var obj = pocContacts[i]
        var projection = { text: 1, value: 1 }
        var projectedObj = project(obj, projection)
        console.log(projectedObj)
        results.push(projectedObj)
      }
      console.log(
        'Returning Property POC Options: ' + JSON.stringify(results, null, 2)
      )
      return results
    }
  },
  methods: {
    ...mapActions('company', [
      'loadProperties',
      'saveProperty',
      'getProperty',
      'getPropertyContacts',
      'createPropertyOnCallNumber'
    ]),
    ...mapActions('lookups', ['getLookupStates', 'getLookupCountries']),
    toggleModal () {
      this.modalOpen = !this.modalOpen
    },
    doLoadProperty () {
      if (!this.propertyId) {
        return new Promise((resolve) => {
          resolve()
        })
      } else {
        return this.getProperty(this.propertyId).then((r) => {
          this.propertyForEdit = r.data.property
          if (!this.propertyForEdit.address) {
            this.propertyForEdit.address = {}
          }
          if (this.propertyForEdit.insurancePolicies.length > 0) {
            this.insurancePolicy = this.propertyForEdit.insurancePolicies[0]
          }
        })
      }
    },
    async doLoadPropertyContacts () {
      if (!this.propertyId) {
        return new Promise((resolve) => {
          resolve()
        })
      } else {
        return this.getPropertyContacts(this.propertyId).then((result) => {
          this.propertyPocContacts = result.data.people
        })
      }
    },
    doCreatePropertyOnCallNumber (id) {
      this.createPropertyOnCallNumber(id).then((result) => {
        this.propertyForEdit.onCallPhoneNumberFriendlyFormat =
          result.data.newPhoneNumberFriendly
        this.propertyForEdit.onCallPhoneNumberE164Format =
          result.data.newPhoneNumberE164
      })
    },
    async SaveProperty () {
      if (this.$refs.addressForm && !this.$refs.addressForm.validate()) {
        return
      }
      {
        const newProperty = this.propertyForEdit
        this.insurancePolicy.deductible = this.insurancePolicy.deductible === '' ? 0 : this.insurancePolicy.deductible
        if (this.insurancePolicy.policyNumber !== null || this.insurancePolicy.contactNumber !== null || this.insurancePolicy.deductible !== 0) {
          this.insurancePolicy.deductible = (this.insurancePolicy.deductible === '') ? null : this.insurancePolicy.deductible
          this.propertyForEdit.insurancePolicies[0] = this.insurancePolicy
        }
        this.saveProperty(newProperty).then(() => {
          this.$toasted.show('Property Saved.', { duration: 4000 })
        }).then(() => this.$router.push({name: 'Properties'}))
      }
    }
  }
}
</script>
